import TotalDonationAmount from './TotalDonationAmount'

export default TotalDonationAmount
